import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useRef } from 'react';

import Icon from '../icons/icon';

type PropsType = {
    value: number;
    onChange: (selected: number) => void;
};

const Array = styled.div`
    display: flex;
    justify-content: space-around;
`;

const Stars = ({ value, onChange }: PropsType) => {
    const stars = [];
    const starsRef = useRef<HTMLDivElement>(null);
    const theme = useTheme();

    for (let i = 1; i <= 5; i++) {
        stars.push(
            <Icon
                key={i}
                color={i <= value ? 'gold' : theme.palette.grey[200]}
                name='star'
                size='xlarge'
                onClick={() => {
                    onChange(i);
                }}
            />
        );
    }
    return <Array ref={starsRef}>{stars}</Array>;
};

export default Stars;
